import { ColDef } from "ag-grid-community";
import { MarkdownCellRenderer } from "../MarkdownCellRenderer";

export const useTableData = () => {
	const defaultColDef: ColDef = {
		filter: false,
		floatingFilter: false,
		sortable: false,
		resizable: false,
		editable: false,
	};

	const columns: ColDef[] = [
		{
			field: "AssetName",
			headerName: "Asset",
			sortable: true,
			flex: 1,
			minWidth: 60,
		},
		{
			field: "Title",
			headerName: "Title",
			sortable: false,
			flex: 1,
			minWidth: 160,
		},
		{
			field: "Content",
			headerName: "Content",
			sortable: false,
			flex: 5,
			minWidth: 95,
			wrapText: true,
			autoHeight: true,
			cellStyle: {
				textAlign: "left",
			},
			cellRenderer: MarkdownCellRenderer,
		},
		{
			field: "Author",
			headerName: "Author",
			sortable: false,
			flex: 1,
			minWidth: 95,
		},
	];

	return {
		columns,
		defaultColDef,
	};
};
